import { render, staticRenderFns } from "./MathAndSymbol.vue?vue&type=template&id=c8068fb2&"
import script from "./MathAndSymbol.vue?vue&type=script&lang=js&"
export * from "./MathAndSymbol.vue?vue&type=script&lang=js&"
import style0 from "./MathAndSymbol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports